const ALLOWED_TAGS = new Set(['strong', 'em', 'mark', 'br', 'b', 'i', 'p', 'h2', 'h3', 'ul', 'ol', 'li', 'a']);

/**
 * Escape text, then re-allow a small whitelist of formatting tags.
 * Use this for every `{@html}` interpolation.
 */
export function sanitizeHtml(input: unknown): string {
  if (input == null) return '';
  const raw = String(input);
  const escaped = raw
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  const withLinks = escaped.replace(
    /&lt;a\s+href=&quot;(https?:\/\/[^"&]+)&quot;&gt;([\s\S]*?)&lt;\/a&gt;/g,
    (_full, href, label) => `<a href="${href}">${label}</a>`
  );

  return withLinks.replace(/&lt;(\/?)([a-zA-Z0-9]+)(?:(?!&gt;).)*&gt;/g, (_full, slash, tag) => {
    const name = String(tag).toLowerCase();
    if (!ALLOWED_TAGS.has(name) || name === 'a') return '';
    return slash ? `</${name}>` : `<${name}>`;
  });
}
